<template>
  <div class="page close-picker">
    <div class="page-content">
      <div class="listPage">
      <!-- form Yann & TLV -->
        <div class="layoutTop"/>
        <b-container fluid>
          <b-row>
            <b-col md="10" offset-md="1">
              <back-button returnUrl="/attachments/"></back-button>
              <div class="panel21 panel-default">
                <div class="panel-heading">
                  <h4 class="content-block labelAccordionForm">
                    <img src="../../assets/static/images/icons/paperclip.png" class="formIcon formIconSmall"/>
                    {{ $t('attachments.create_invoice') }}
                  </h4>
                </div>

                <form-accordion :title="$t('common.formsSubTitle.gnrl')">
                  <b-row>
                    <b-col>
                      <form-write-group-label-input isMandatory inputType="date"
                        :inputLabel="$t('attachments.dlvry_date')" :placeholderValue="$t('common.placeholder_format_date')"
                        v-model="dateOfIssue">
                      </form-write-group-label-input>
                    </b-col>
                    <b-col>
                      <form-write-group-label-input isMandatory
                        :inputLabel="createInvoice_Reference" :placeholderValue="createInvoice_Reference"
                        v-model="identifier">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <form-write-group-label-input isMandatory inputType="date"
                        :inputLabel="createInvoice_Selectadate" :placeholderValue="createInvoice_Selectadate"
                        v-model="dateOfSale">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                </form-accordion>

                <hr/>

                <form-accordion :title="$t('common.formsSubTitle.rcpt')">
                  <b-row class="form-group" :class="colorBottomButton">
                    <b-col sm="4" class="createInvoicePicker">
                      <a href="#" data-picker=".contactListPicker" class="link open-picker button button-round">
                        {{ $t('common.slct_ctcts') }}
                      </a>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <form-write-group-label-input v-model="debtorName" isMandatory
                        :inputLabel="createInvoice_FullName"
                        :placeholderValue="createInvoice_FullName">
                      </form-write-group-label-input>
                    </b-col>
                    <b-col>
                      <form-write-group-label-input v-model="debtorAddress"
                        :inputLabel="createInvoice_Address"
                        :placeholderValue="createInvoice_Address">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <form-write-group-label-input v-model="debtorCodeAddress"
                        :inputLabel="createInvoice_City"
                        :placeholderValue="createInvoice_City">
                      </form-write-group-label-input>
                    </b-col>
                    <b-col>
                      <form-write-group-label-input v-model="debtorZipCode"
                        :inputLabel="createInvoice_Zipcode"
                        :placeholderValue="createInvoice_Zipcode">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <form-write-group-label-input v-model="debtorCountry"
                        :inputLabel="createInvoice_Country"
                        :placeholderValue="createInvoice_Country">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                </form-accordion>

                <hr/>

                <form-accordion :title="$t('common.formsSubTitle.sndr')">
                  <b-row class="form-group">
                    <b-col>
                      <form-write-group-label-input v-model="creditorIdentifier" isMandatory
                        :inputLabel="createInvoice_Identifier">
                      </form-write-group-label-input>
                    </b-col>
                    <b-col>
                      <form-write-group-label-input v-model="rcs"
                        :inputLabel="createInvoice_Registrynumber"
                        :placeholderValue="createInvoice_Registrynumber">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <form-write-group-label-input v-model="identifierTVA"
                        :inputLabel="createInvoice_TVAnumber"
                        :placeholderValue="createInvoice_TVAnumber">
                      </form-write-group-label-input>
                    </b-col>
                    <b-col>
                      <form-write-group-label-input v-model="creditorAddress" isMandatory
                        :inputLabel="createInvoice_Address"
                        :placeholderValue="createInvoice_Address">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <form-write-group-label-input v-model="creditorCodeAddress" isMandatory
                        :inputLabel="createInvoice_City"
                        :placeholderValue="createInvoice_City">
                      </form-write-group-label-input>
                    </b-col>
                    <b-col>
                      <form-write-group-label-input v-model="creditorZipCode" isMandatory
                        :inputLabel="createInvoice_Zipcode"
                        :placeholderValue="createInvoice_Zipcode">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <form-write-group-label-input v-model="creditorCountry" isMandatory
                        :inputLabel="createInvoice_Country"
                        :placeholderValue="createInvoice_Country">
                      </form-write-group-label-input>
                    </b-col>
                    <b-col>
                      <form-write-group-label-input v-model="legalForm"
                        :inputLabel="createInvoice_LegalForm"
                        :placeholderValue="createInvoice_LegalForm">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <form-write-group-label-input v-model="amountOfCapital"
                        inputType="number"
                        :inputLabel="$t('common.shr_cptl') + ' (€)'"
                        :placeholderValue="createInvoice_amount">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="5" sm="2" class="colorBottomButton">
                      <label for="fileLogo" class="inputFileButton attachementCreateInvoiceButtonLength" style="width: 90%;">
                        {{ $t('common.lgo') }}
                      </label>
                    </b-col>
                    <input type="file" name="fileLogo" id="fileLogo" class="inputfile" @change="onFileChange"/>
                    <b-col cols="7" sm="10">
                      <input class="form-control" name="filename" :placeholder="createInvoice_Choosefile" type="text" v-model="logoName" disabled>
                    </b-col>
                  </b-row>
                </form-accordion>

                <hr/>

                <form-accordion :title="$t('common.formsSubTitle.srvc')">
                  <b-row>
                    <b-col>
                      <form-write-group-label-input v-model="remittanceInformation" isMandatory
                        :inputLabel="createInvoice_Reason"
                        :placeholderValue="createInvoice_Reason">
                      </form-write-group-label-input>
                    </b-col>
                    <b-col>
                      <form-write-group-label-input v-model="amountHT" isMandatory
                        inputType="number"
                        :inputLabel="createInvoice_Pretaxamount"
                        :placeholderValue="createInvoice_Pretaxamount">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <form-write-group-label-input v-model="percentTVA" isMandatory
                        inputType="number"
                        :inputLabel="createInvoice_VAT"
                        :placeholderValue="createInvoice_VAT">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                </form-accordion>

                <hr/>

                <form-accordion :title="$t('common.formsSubTitle.othr')">
                  <b-row>
                    <b-col sm="6">
                      <form-write-group-label-input v-model="paymentsDate" isMandatory
                        inputType="date"
                        :inputLabel="$t('common.pymnts_dates')"
                        :placeholderValue="$t('common.datepicker_format_date')">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                </form-accordion>

                <div class="picker-modal contactListPicker">
                  <div class="toolbar">
                    <div class="toolbar-inner">
                      <div class="left"></div>
                      <div class="right"><a href="#" class="close-picker" @click="contactListPickerCloseButton">{{ $t('common.dne') }}</a></div>
                    </div>
                  </div>
                  <div class="picker-modal-inner scrollablePicker">
                    <form data-search-list=".contactRecipientList" data-search-in=".item-title" class="searchbar searchbar-init">
                      <div class="searchbar-input">
                        <input type="search" :placeholder="createInvoice_Search"><a href="#" class="searchbar-clear"></a>
                      </div>
                      <a href="#" class="searchbar-cancel">
                        {{ $t('common.cncl') }}
                      </a>
                    </form>
                    <div class="list-block contactRecipientList">
                      <f7-list contacts class="contactRecipientList">
                        <f7-list-group v-for="(group, key) in this.contactSelectionList" :key="key">
                          <f7-list-item :title="key" group-title></f7-list-item>
                          <li v-for="contact in group" :key="'contact-list-option-' + contact.id" :value="contact.id">
                            <label class="label-radio item-content" @click="contactListPickerCloseButton">
                              <input type="radio" name="countryPickerRadio" :value="contact.id">
                              <div class="item-inner">
                                <div class="item-title">{{ contact.name }}</div>
                              </div>
                            </label>
                          </li>
                        </f7-list-group>
                      </f7-list>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2" offset-md="9">
              <button round
                class="milkyBlockBlack button-action firstButtonMarginTop"
                @click="createInvoice('cloud')">
                <i class="icon fa fa-save"></i>
                <span>{{ $t('common.sve') }}</span>
              </button>
            </b-col>
          </b-row>
        </b-container>
        <b-row>
          <div class="toolbarPageBottomBlank"></div>
        </b-row>
      </div>
    </div>
  </div>
  <!-- </f7-page> -->
</template>

<script>

import { jsPDF as JsPDF } from 'jspdf'
import * as pdfjsLib from 'pdfjs-dist'
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`

import backButton from '@/components/common/backButton.vue'
// import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
// import pageNavBar from '@/components/common/pageNavBar.vue'

import datePickerMixin from '@/mixins/datePickerMixin'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'attachmentsCreateInvoice',
  components: {
    // JsPDF,
    'back-button': backButton,
    // 'bottom-toolbar': bottomToolbar,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    // 'page-nav-bar': pageNavBar
  },
  mixins: [datePickerMixin],
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      dateOfIssue: '',
      identifier: '',
      dateOfSale: '',
      debtorName: '',
      idDebtorName: '',
      debtorEmail: '',
      debtorBankAccount: '',
      debtorAddress: '',
      debtorCodeAddress: '',
      debtorZipCode: '',
      debtorCountry: '',
      creditorIdentifier: '',
      rcs: '',
      tradeDirectory: '',
      creditorAddress: '',
      creditorCodeAddress: '',
      creditorZipCode: '',
      creditorCountry: '',
      legalForm: '',
      amountOfCapital: 0,
      logoAttachment: '',
      logoName: '',
      remittanceInformation: '',
      price: 0,
      amountHT: 0,
      percentTVA: 0,
      amountTVA: 0,
      amountTTC: 0,
      paymentsDate: '',
      identifierTVA: '',
      contactDebtors: [],
      contactSelectionList: [],
      contactSelected: '',
      isSmartphone: false
    }
  },
  created () {
    this.createInvoice_CreateInvoice = this.$i18n.t('attachments.create_invoice')
    this.createInvoice_Selectadate = this.$i18n.t('attachments.dlvry_date')
    this.createInvoice_Reference = this.$i18n.t('common.rfrnc')
    this.createInvoice_FullName = this.$i18n.t('common.fll_nm')
    this.createInvoice_Address = this.$i18n.t('common.adrs')
    this.createInvoice_City = this.$i18n.t('common.cty')
    this.createInvoice_Zipcode = this.$i18n.t('common.zp_code')
    this.createInvoice_Country = this.$i18n.t('common.ctry')
    this.createInvoice_Identifier = this.$i18n.t('common.sndr_name')
    this.createInvoice_Registrynumber = this.$i18n.t('common.rgstr_number')
    this.createInvoice_TVAnumber = this.$i18n.t('common.tva_nbr')
    this.createInvoice_amount = this.$i18n.t('common.amnt')
    this.createInvoice_Choosefile = this.$i18n.t('common.chse_file')
    this.createInvoice_Reason = this.$i18n.t('common.rsn')
    this.createInvoice_Pretaxamount = this.$i18n.t('common.prtx_amnt')
    this.createInvoice_VAT = this.$i18n.t('common.vat')
    this.createInvoice_Search = this.$i18n.t('common.srch')
    this.createInvoice_LegalForm = this.$i18n.t('common.lgl_frm')
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    let that = this
    that.contactDebtors = this.$engine.contacts.get()
    var contactList = {}
    for (var j = 0; j < this.$engine.contacts.get().length; j++) {
      var firstLetter = this.$engine.contacts.get(j).label.substr(0, 1).toUpperCase()
      if (!Object.hasOwn(contactList, firstLetter)) {
        contactList[firstLetter] = []
      }
      contactList[firstLetter].push({label: this.$engine.contacts.get(j).label, iban: this.$engine.contacts.get(j).iban, login: this.$engine.contacts.get(j).login, name: this.$engine.contacts.get(j).name, id: this.$engine.contacts.get(j).id})
      contactList[firstLetter].sort()
    }
    this.contactSelectionList = this.orderKeys(contactList)
    this.creditorIdentifier = this.$engine.user.get().name
    this.creditorAddress = this.$engine.user.get().address
    this.creditorCodeAddress = this.$engine.user.get().city
    this.creditorZipCode = this.$engine.user.get().zip_code
    this.creditorCountry = this.$engine.user.get().country
    this.legalForm = this.$engine.user.get().legalForm
    this.amountOfCapital = this.$engine.user.get().amountOfCapital
    this.identifierTVA = this.$engine.user.get().identifierTVA
  },
  methods: {
    createInvoice (type) {
      let that = this
      if (this.verifyData() === true) {
        this.amountHT = parseFloat(this.amountHT).toFixed(2)
        this.percentTVA = parseFloat(this.percentTVA).toFixed(2)
        this.amountTVA = (parseFloat(this.amountHT) * parseFloat(this.percentTVA) / 100).toFixed(2)
        this.amountTTC = (parseFloat(this.amountHT) + parseFloat(this.amountTVA)).toFixed(2)

        var imgData = this.logoAttachment
        var doc = new JsPDF()
        if (this.logoAttachment !== '') {
          doc.addImage(imgData, 'PNG', 12, 15, 24, 24)
        }
        doc.setFontSize(12)
        // doc.setFont('times')
        doc.setFont('helvetica')
        doc.setFont(undefined, 'bold')
        doc.setFont('helvetica')
        doc.text(this.creditorIdentifier, 8, 55)
        doc.setFont(undefined, 'normal')
        doc.setFont('helvetica')
        doc.text(this.creditorAddress, 8, 61)
        doc.text(this.creditorZipCode + ' ' + this.creditorCodeAddress + ' ' + this.creditorCountry, 8, 67)
        doc.setFont(undefined, 'bold')
        doc.setFont('helvetica')
        doc.text(this.debtorName, 130, 30)
        doc.setFont(undefined, 'normal')
        doc.setFont('helvetica')
        doc.text(this.debtorAddress, 130, 36)
        doc.text(this.debtorZipCode + ' ' + this.debtorCodeAddress + ' ' + this.debtorCountry, 130, 42)
        doc.setFont(undefined, 'bold')
        doc.setFont('helvetica')
        doc.text(that.$t('attachments.invce') + ' n° :', 130, 70)
        doc.setFont(undefined, 'normal')
        var invoice = this.identifier
        doc.setFont('helvetica')
        doc.text(invoice, 155, 70)
        doc.setFont(undefined, 'bold')
        doc.setFont('helvetica')
        doc.text(that.$t('attachments.dlvry_date') + ' :', 130, 76)
        doc.setFont(undefined, 'normal')
        var dateOfIssue = this.dateOfIssue
        doc.setFont('helvetica')
        doc.text(dateOfIssue, 167, 76)
        doc.setFont(undefined, 'bold')
        doc.setFont('helvetica')
        doc.text(that.$t('attachments.blng_date') + ' :', 130, 82)
        doc.setFont(undefined, 'normal')
        var dateOfSale = this.dateOfSale
        doc.setFont('helvetica')
        doc.text(dateOfSale, 171, 82)
        doc.setFillColor(230, 230, 230)
        doc.setDrawColor(0)
        doc.rect(8, 100, 20, 15, 'FD')
        doc.rect(28, 100, 132, 15, 'FD')
        doc.rect(160, 100, 35, 15, 'FD')
        doc.setFontSize(12)
        doc.setFont(undefined, 'normal')
        doc.setFont('helvetica')
        doc.text(that.$t('common.qtty'), 10, 109)
        doc.text(that.$t('common.rsn'), 78, 109)
        doc.text(that.$t('common.amnt') + ' ' + that.$t('common.current_currency'), 164, 109)
        doc.setFillColor(250, 250, 250)
        doc.setDrawColor(0)
        doc.rect(8, 115, 20, 30, 'FD')
        doc.rect(28, 115, 160, 30, 'FD')
        doc.rect(160, 115, 35, 30, 'FD')
        doc.setFont('helvetica')
        doc.text('1', 17, 120)
        doc.text(this.remittanceInformation, 31, 120)
        var amountHT = this.amountHT
        doc.text(amountHT.toString(), 164, 120)
        doc.setFillColor(250, 250, 250)
        doc.setDrawColor(0)
        doc.rect(8, 150, 160, 17, 'FD')
        doc.rect(160, 150, 35, 17, 'FD')
        doc.setFont('helvetica')
        doc.text(that.$t('common.total_amount_no_tax'), 119, 155)
        var percentTVA = that.$t('common.ttl_amnt_tva') + this.percentTVA.toString() + '%'
        doc.text(percentTVA.toString(), 95, 160)
        doc.text(amountHT.toString(), 164, 155)
        doc.text(this.amountTVA.toString(), 164, 160)
        doc.setFont(undefined, 'bold')
        doc.setFont('helvetica')
        doc.text(that.$t('common.ttl_amnt_with_tax_to_pay'), 98, 165)
        // var amountTTC = this.amountTTC + '€'
        var amountTTC = this.amountTTC
        doc.setFont('helvetica')
        doc.text(amountTTC.toString(), 164, 165)
        doc.setFont(undefined, 'bold')
        doc.setFont('helvetica')
        doc.text(that.$t('common.pymnt_date'), 8, 180)
        doc.setFont(undefined, 'normal')
        if (this.paymentsDate !== '') {
          var paymentsDate = this.paymentsDate
          doc.setFont('helvetica')
          doc.text(paymentsDate, 50, 180)
        }
        doc.setFont(undefined, 'italic')
        doc.setFontSize(9)
        doc.setFont('helvetica')
        doc.text('Le défaut de paiement à échéance entraîne le paiement d\'un intérêt de retard d\'un taux égal à 3 fois le taux d\'intérêt légal à compter', 8, 187)
        doc.text('du premier jour ouvré de retard, une indemnité forfaitaire de compensation des frais de recouvrement de 40 euros et tous dommages', 8, 192)
        doc.text('et intérêts complémentaires', 8, 197)
        doc.setFont(undefined, 'normal')
        doc.setFontSize(12)
        var endLineOne = this.creditorIdentifier
        if (this.legalForm !== '') {
          endLineOne = endLineOne + ' ' + this.legalForm
        }
        if (this.amountOfCapital !== '') {
          endLineOne = endLineOne + ', société au capital social de ' + this.amountOfCapital + ' euros'
        }
        doc.setFont('helvetica')
        doc.text(endLineOne, 8, 270)
        var endLineTwo = ''
        if (this.rcs !== '') {
          endLineTwo = 'RCS de paris n° ' + this.rcs
        }
        if (this.identifierTVA !== '') {
          if (endLineTwo.length > 0) {
            endLineTwo = endLineTwo + ' - '
          }
          endLineTwo = endLineTwo + 'TVA n° ' + this.identifierTVA
        }
        if (this.tradeDirectory !== '') {
          if (endLineTwo.length > 0) {
            endLineTwo = endLineTwo + ' - '
          }
          endLineTwo = endLineTwo + 'Répertoire des métiers n°' + this.tradeDirectory
        }
        var pos = 275
        if (endLineTwo.length > 0) {
          doc.setFont('helvetica')
          doc.text(endLineTwo, 8, pos)
          pos = pos + 5
        }
        var addrCred = 'Siège social : ' + this.creditorAddress + ' - ' + this.creditorZipCode + ' ' + this.creditorCodeAddress + ' ' + this.creditorCountry
        doc.setFont('helvetica')
        doc.text(addrCred, 8, pos)
        if (type === 'device') {
          doc.save('Invoice.pdf')
          this.cleanData()
          that.$f7.modal({
            title: that.$t('attachments.attchmnts_svd'),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/attachments/', force: false, ignoreCache: false})
          }, 2000)
        } else if (type === 'cloud') {
          var file = doc.output('datauristring')
          // Code OCR
          var element = this
          var pdfData = atob(file.split(',')[1])
          var loadingTask = pdfjsLib.getDocument({data: pdfData})
          var textDataPromise = loadingTask.promise.then(function (pdf) {
            var pageNumber = 1
            return pdf.getPage(pageNumber).then(function (page) {
              return page.getTextContent().then(function (text) {
                return text.items.map(function (s) { return s.str }).join('\n')
              })
            })
          }, function (reason) {
            // PDF loading error
            console.error(reason)
          })
          .catch(error => {
            errorMessageAlert(error, that)
          })
          textDataPromise.then(function (textData) {
            that.$engine.attachments
              .uploadWebapp(
                element.identifier,
                0,
                'application/pdf',
                that.$t('attachments.invce') + '_' + element.identifier + '.pdf',
                file,
                textData,
                that.debtorName,
                that.debtorEmail,
                that.debtorBankAccount,
                that.remittanceInformation,
                that.amountTTC,
                that.paymentsDate,
                'create', // originalPage
                '',
                that.idDebtorName
              )
              .then(response => {
                element.status = response.status
                if (response.status === 200) {
                  // element.$f7.alert('', 'Attachment imported')
                  element.cleanData()
                  element.$bus.$emit('refresh-cache-attachments')
                  that.$f7.modal({
                    title: that.$t('attachments.attchmnts_svd'),
                    text: '<span class="preloader"></span>'
                  })
                  setTimeout(function () {
                    that.$f7.closeModal()
                    loadPage(that, {url: '/attachments/', force: false, ignoreCache: false})
                  }, 2000)
                }
              })
              .catch(error => {
                errorMessageAlert(error, element)
              })
          })
          .catch(error => {
            errorMessageAlert(error, that)
          })
          // Code OCR
        } else if (type === 'createPayments') {
          let attachmentObj = {
            fromCloudList: true,
            id: 0,
            name: '',
            data: '',
            amount: 0,
            debtorName: '',
            reference: '',
            executionDate: ''
          }
          var fileCreatePayments = doc.output('datauristring')
          // Code OCR
          var elementCreatePayments = this
          attachmentObj.name = that.$t('common.invce') + '_' + elementCreatePayments.identifier + '.pdf'
          attachmentObj.data = fileCreatePayments
          attachmentObj.id = ''
          attachmentObj.amount = this.price
          attachmentObj.debtorName = this.debtorName
          attachmentObj.reference = ''
          attachmentObj.executionDate = this.paymentsDate
          that.$engine.settings.set({preChargedFile: attachmentObj})
          loadPage(this, {url: '/payments/newPayments/'})
          this.cleanData()
        }
        this.$f7.closeModal()
      }
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      this.createImage(files[0])
      this.logoName = files[0].name
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this
      reader.onload = (e) => {
        vm.logoAttachment = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeImage: function () {
      this.logoAttachment = ''
    },
    cleanData: function () {
      this.dateOfIssue = ''
      this.identifier = ''
      this.dateOfSale = ''
      this.debtorName = ''
      this.idDebtorName = ''
      this.debtorAddress = ''
      this.debtorCodeAddress = ''
      this.debtorZipCode = ''
      this.debtorCountry = ''
      this.creditorIdentifier = ''
      this.rcs = ''
      this.tradeDirectory = ''
      this.creditorAddress = ''
      this.creditorCodeAddress = ''
      this.creditorZipCode = ''
      this.creditorCountry = ''
      this.legalForm = ''
      this.amountOfCapital = 0
      this.logoAttachment = ''
      this.logoName = ''
      this.remittanceInformation = ''
      this.price = 0
      this.amountHT = 0
      this.percentTVA = 0
      this.amountTVA = 0
      this.amountTTC = 0
      this.paymentsDate = ''
      this.identifierTVA = ''
    },

    verifyData: function () {
      var status = false
      if (this.dateOfIssue === '') {
        this.$f7.alert('', this.$t('errors.invld_dt_of_issue'))
      } else if (this.identifier === '') {
        this.$f7.alert('', this.$t('errors.invld_invc_nmbr'))
      } else if (this.dateOfSale === '') {
        this.$f7.alert('', this.$t('errors.invld_dt_of_sale'))
      } else if (this.debtorName === '') {
        this.$f7.alert('', this.$t('errors.invld_dbtr_nm'))
      } else if (this.creditorIdentifier === '') {
        this.$f7.alert('', this.$t('errors.invld_crdtr_idntfr'))
      } else if (this.creditorAddress === '') {
        this.$f7.alert('', this.$t('errors.invld_crdtr_addrss'))
      } else if (this.creditorCodeAddress === '') {
        this.$f7.alert('', this.$t('errors.invld_crdtr_ct_addrss'))
      } else if (this.creditorZipCode === '') {
        this.$f7.alert('', this.$t('errors.invld_zip_code'))
      } else if (this.creditorCountry === '') {
        this.$f7.alert('', this.$t('errors.invld_cntry'))
      } else if (this.remittanceInformation === '') {
        this.$f7.alert('', this.$t('errors.invld_rmttnc_info'))
      } else if (this.amountHT === 0) {
        this.$f7.alert('', this.$t('errors.invld_pre_tax_amnt'))
      } else if (this.percentTVA === '') {
        this.$f7.alert('', this.$t('errors.invld_tva'))
      } else {
        status = true
      }
      return status
    },
    orderKeys: function (obj) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    contactListPickerCloseButton () {
      let that = this
      this.contactSelected = this.Dom7('input[name=countryPickerRadio]:checked').val()
      for (let i = 0; i < this.contactDebtors.length; i++) {
        if (that.contactDebtors[i].id.toString() === this.contactSelected) {
          // TLV 25/09/2019 : ajout de l'id du contact sélectionné pour l'envoyer à la modé
          that.idDebtorName = that.contactDebtors[i].id.toString()
          that.debtorName = that.contactDebtors[i].name
          that.debtorEmail = that.contactDebtors[i].login
          that.debtorBankAccount = that.contactDebtors[i].iban
          that.debtorAddress = that.contactDebtors[i].address
          that.debtorCodeAddress = that.contactDebtors[i].city
          that.debtorZipCode = that.contactDebtors[i].zipCode
          that.debtorCountry = that.contactDebtors[i].country
        }
      }
      // TLV 04/12/2019 : Fermeture automatique de la liste après avoir choisi un élément
      this.$f7.closeModal('.contactListPicker.modal-in')
    },
    calendarDateOfIssue () {
      /* eslint-disable no-undef */
      let that = this
      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.dateOfIssue = dateResult
        })
      }
      /* eslint-enable no-undef */
    },
    paymentsDateOfIssue () {
      if (this.dateOfIssue !== undefined) {
        if (this.dateOfIssue.length > 0) {
          return this.dateOfIssue
        } else {
          return this.$t('common.slct_date')
        }
      } else {
        return this.$t('common.slct_date')
      }
    },
    calendarDateOfSale () {
      /* eslint-disable no-undef */
      let that = this
      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.dateOfSale = dateResult
        })
      }
      /* eslint-enable no-undef */
    },
    paymentsDateOfSale () {
      if (this.dateOfSale !== undefined) {
        if (this.dateOfSale.length > 0) {
          return this.dateOfSale
        } else {
          return this.$t('common.slct_date')
        }
      } else {
        return this.$t('common.slct_date')
      }
    },
    calendarPaymentsDate () {
      /* eslint-disable no-undef */
      let that = this
      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.paymentsDate = dateResult
        })
      }
      /* eslint-enable no-undef */
    },
    paymentsExecutionDate () {
      if (this.paymentsDate !== undefined) {
        if (this.paymentsDate.length > 0) {
          return this.paymentsDate
        } else {
          return this.$t('common.slct_date')
        }
      } else {
        return this.$t('common.slct_date')
      }
    }
  }
}
</script>
<style scoped>
 .inputfile2 {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
.inputfile2 + label {
  text-align: center;
  color: #12bcf1;
  width: 56%;
  border: 1px solid #12bcf1;
  margin-right: 50px;
  background-color: #eff3f9;
  border-radius: 3px;
  display: inline-block;
  height: 30px;
  line-height: 30px;
}
.blueText {
  color: #12bcf1;
}
.floating-block-popup {
    width: 50%;
    margin-left: 25%;
}
.floating-button-popup {
  right: 15px;
  bottom: 15px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  z-index: 1500;
  background-color: #12bcf1;
  color: #fff;
  overflow: hidden;
  -webkit-transition-duration: .3s;
  transition-duration: .3s;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.attachementCreateInvoiceButtonLength {
  width: 100%;
}
.inputFileButton {
  float: left;
}
</style>
